import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAboFixedBar, LazyAboPaywall, LazyAboTimeline, LazyAboUpsellDecision, LazyAppBanner, LazyAppCourseCategorySlider, LazyAppCourseList, LazyAppCourses, LazyAppHeader, LazyAppHomeDownloadApp, LazyAppHomeNextLiveCall, LazyAppLegalConfirmationModal, LazyAppLiveCalls, LazyAppMainNavigationDesktop, LazyAppMainNavigationMobile, LazyAppMainNavigation, LazyAppOnboardingCta, LazyAppSessionVideo, LazyAppSettingsAccountDelete, LazyAppSettingsAccountEmail, LazyAppSettingsAccountPasswordEdit, LazyAppSettingsAccountPassword, LazyAppSettingsSubscriptionListItemSkeleton, LazyAppSettingsSubscriptionListItem, LazyAppSettingsSubscriptionList, LazyAppSettingsSubscription, LazyAppSettings, LazyAppSubscriptionUpsell, LazyAudioPlayerControlForward30, LazyAudioPlayerControlNext, LazyAudioPlayerControlPlayButton, LazyAudioPlayerControlPlaybackRate, LazyAudioPlayerControlPrev, LazyAudioPlayerControlReplay10, LazyAudioPlayerControlSeekbar, LazyAudioPlayerMinDesktopCenter, LazyAudioPlayerMinDesktopLeft, LazyAudioPlayerMinDesktopRight, LazyAudioPlayerMinDesktop, LazyAudioPlayerMinMobileExpanded, LazyAudioPlayerMinMobileLeft, LazyAudioPlayerMinMobileRight, LazyAudioPlayerMinMobile, LazyAudioPlayerMin, LazyAudioPlayer, LazyAuthConfirmationPage, LazyAuthConfirmationSuccessPage, LazyAuthForgottenPasswordNewPage, LazyAuthForgottenPasswordPage, LazyAuthFormButtonApple, LazyAuthFormButtonGoogle, LazyAuthFormConfirmationInstruction, LazyAuthFormNewPassword, LazyAuthFormPasswordInstruction, LazyAuthFormSigninSlim, LazyAuthFormSignin, LazyAuthFormSignupPassword, LazyAuthFormSignupSlim, LazyAuthFormSignup, LazyAuthForm, LazyAuthLoginPage, LazyBlogPostItem, LazyBlogPostList, LazyCheckoutPageBillingAddress, LazyCheckoutPageChangePlan, LazyCheckoutPageChecklist, LazyCheckoutPageContactInfo, LazyCheckoutPageDescription, LazyCheckoutPageError, LazyCheckoutPageExpressCheckout, LazyCheckoutPageFooter, LazyCheckoutPageLegalText, LazyCheckoutPageLogo, LazyCheckoutPageOrSeperator, LazyCheckoutPageOrderDetails, LazyCheckoutPagePaymentMethods, LazyCheckoutPagePricingSummary, LazyCheckoutPagePromoCodeInput, LazyCheckoutPageSecurityInfo, LazyCheckoutPageSkeletonLoader, LazyCheckoutPage, LazyCourseActionsAccess, LazyCourseActionsBuyFixed, LazyCourseActionsBuy, LazyCourseActionsFollow, LazyCourseActionsListen, LazyCourseActionsNoAccess, LazyCourseActionsShareButton, LazyCourseActionsShare, LazyCourseCard, LazyCourseGrid, LazyCourseLessonAccordion, LazyCourseListItemMentor, LazyCourseListItemSkeleton, LazyCourseListItem, LazyCourseModal, LazyCourseOfTheWeekCourse, LazyCourseOfTheWeek, LazyCourseRatingsItem, LazyCourseRatings, LazyCourseRecommendation, LazyCourseSearchModal, LazyCourseSearch, LazyCourseSlider, LazyCourseBundleCourseSingle, LazyCourseBundleCourses, LazyCourseBundleCtaTrial, LazyCourseBundleListItem, LazyCourseBundleSlider, LazyCourseCategoryBundles, LazyCourseCategoryCourses, LazyCourseCategoryDropdown, LazyCourseCategoryFeaturedCategories, LazyCourseCategoryFeaturedCourses, LazyCourseCategoryFeatured, LazyCourseCategoryFilterSkeleton, LazyCourseCategoryFilter, LazyCourseCategoryHeaderSkeleton, LazyCourseCategoryHeader, LazyCourseCategoryOverviewSliderCategories, LazyCourseCategoryOverviewSliderCoursesSlider, LazyCourseCategoryOverviewSliderCourses, LazyCourseCategoryOverviewSlider, LazyCourseCategorySubcategories, LazyCourseCategorySubcategory, LazyCourseLandingpageCtaButton, LazyCourseLandingpageDescription, LazyCourseLandingpageDownloads, LazyCourseLandingpageFeatures, LazyCourseLandingpageForMe, LazyCourseLandingpageHeaderCourse, LazyCourseLandingpageHeaderKnownFroms, LazyCourseLandingpageHeader, LazyCourseLandingpageInfo, LazyCourseLandingpageLearnings, LazyCourseLandingpageLessonsAccordion, LazyCourseLandingpageLessons, LazyCourseLandingpageMentorAbout, LazyCourseLandingpageMentorQualifications, LazyCourseLandingpagePageNavigation, LazyCourseLandingpageWyg, LazyCourseWidgetCommunity, LazyCourseWidgetContent, LazyCourseWidgetInfoSectionAbout, LazyCourseWidgetInfoSectionDownloads, LazyCourseWidgetInfoSectionIntro, LazyCourseWidgetInfoSectionLearnings, LazyCourseWidgetInfoSectionLessonsAccordion, LazyCourseWidgetInfoSectionLessons, LazyCourseWidgetInfoSectionMentorInfo, LazyCourseWidgetInfoSectionMentorQualifications, LazyCourseWidgetInfoSectionWyg, LazyCourseWidgetInfo, LazyCourseWidgetLessonCard, LazyCourseWidgetLessons, LazyCourseWidgetSkeleton, LazyCourseWidget, LazyIndexAwardItem, LazyIndexAwardsSlider, LazyIndexAwards, LazyIndexFeatures, LazyIndexFounders, LazyIndexHeader, LazyIndexHighlightsSlider, LazyIndexMentorBg, LazyIndexQuote, LazyIndexReasonItem, LazyIndexReasons, LazyIndexTestimonialsItem, LazyIndexTestimonials, LazyContainer, LazyContentSection, LazyGridComponent, LazyPage, LazyPost, LazyTheAppFooter, LazyTheAppNavMainDropdownPop, LazyTheAppNavMainDropdown, LazyTheAppNavMainLg, LazyTheAppNavMainSm, LazyTheAppNavMainXs, LazyTheAppNavMain, LazyTheCookiePopup, LazyThePageNavigationList, LazyLiveCallItemVideo, LazyLiveCallItem, LazyLiveCallSessionButton, LazyLiveCallSessionDetails, LazyLiveCallSessionSuccess, LazyLiveCallSessionTimer, LazyLiveCallSessionVideo, LazyLiveCallSignupForm, LazyLiveCallSlider, LazyLiveCalls, LazyMentorListItemSkeleton, LazyMentorListItem, LazyMentorSlider, LazyAppScreen1, LazyAppScreen10, LazyAppScreen11, LazyAppScreen2, LazyAppScreen3, LazyAppScreen4, LazyAppScreen5, LazyAppScreen6, LazyAppScreen7, LazyAppScreen8, LazyAppScreen9, LazyOnboardingCreateAccountForm, LazyOnboardingSelectPlan, LazyOnboardingTopicModalCategorySkeleton, LazyOnboardingTopicModalCategory, LazyOnboardingTopicModal, LazyRedeemChooseCourseItem, LazyRedeemChooseCourse, LazyRedeemPageChoose, LazyRedeemPage, LazyRedeemStepLogin, LazyRedeemStepValidation, LazyAudioComponent, LazyAvatarGroup, LazyBannerApp, LazyBottomBarFixed, LazyBreadcrumbs, LazyButtonComponent, LazyCheckList, LazyClampedText, LazyCountdownTimer, LazyErrorComponent, LazyFaqComponent, LazyFaqQuestion, LazyFeatureListItem, LazyFeatureList, LazyFormComponentInput, LazyFormComponentSuccess, LazyFormComponent, LazyFormInput, LazyFortuneWheelComponent, LazyHeaderComponent, LazyHtmlComponent, LazyIllustration, LazyImageComponent, LazyLogoCloud, LazyLogo, LazyModalComponent, LazyProcessComponent, LazyProgressRing, LazyReviewComponent, LazyReviewItem, LazyReviewSliderComponent, LazyRichTextComponent, LazyShareButtons, LazyShareComponent, LazySitemapComponent, LazyStarComponent, LazyStarRatingComponent, LazyTallyForm, LazyTheBannerTop, LazyVimeoComponent } from '#components'
const lazyGlobalComponents = [
  ["AboFixedBar", LazyAboFixedBar],
["AboPaywall", LazyAboPaywall],
["AboTimeline", LazyAboTimeline],
["AboUpsellDecision", LazyAboUpsellDecision],
["AppBanner", LazyAppBanner],
["AppCourseCategorySlider", LazyAppCourseCategorySlider],
["AppCourseList", LazyAppCourseList],
["AppCourses", LazyAppCourses],
["AppHeader", LazyAppHeader],
["AppHomeDownloadApp", LazyAppHomeDownloadApp],
["AppHomeNextLiveCall", LazyAppHomeNextLiveCall],
["AppLegalConfirmationModal", LazyAppLegalConfirmationModal],
["AppLiveCalls", LazyAppLiveCalls],
["AppMainNavigationDesktop", LazyAppMainNavigationDesktop],
["AppMainNavigationMobile", LazyAppMainNavigationMobile],
["AppMainNavigation", LazyAppMainNavigation],
["AppOnboardingCta", LazyAppOnboardingCta],
["AppSessionVideo", LazyAppSessionVideo],
["AppSettingsAccountDelete", LazyAppSettingsAccountDelete],
["AppSettingsAccountEmail", LazyAppSettingsAccountEmail],
["AppSettingsAccountPasswordEdit", LazyAppSettingsAccountPasswordEdit],
["AppSettingsAccountPassword", LazyAppSettingsAccountPassword],
["AppSettingsSubscriptionListItemSkeleton", LazyAppSettingsSubscriptionListItemSkeleton],
["AppSettingsSubscriptionListItem", LazyAppSettingsSubscriptionListItem],
["AppSettingsSubscriptionList", LazyAppSettingsSubscriptionList],
["AppSettingsSubscription", LazyAppSettingsSubscription],
["AppSettings", LazyAppSettings],
["AppSubscriptionUpsell", LazyAppSubscriptionUpsell],
["AudioPlayerControlForward30", LazyAudioPlayerControlForward30],
["AudioPlayerControlNext", LazyAudioPlayerControlNext],
["AudioPlayerControlPlayButton", LazyAudioPlayerControlPlayButton],
["AudioPlayerControlPlaybackRate", LazyAudioPlayerControlPlaybackRate],
["AudioPlayerControlPrev", LazyAudioPlayerControlPrev],
["AudioPlayerControlReplay10", LazyAudioPlayerControlReplay10],
["AudioPlayerControlSeekbar", LazyAudioPlayerControlSeekbar],
["AudioPlayerMinDesktopCenter", LazyAudioPlayerMinDesktopCenter],
["AudioPlayerMinDesktopLeft", LazyAudioPlayerMinDesktopLeft],
["AudioPlayerMinDesktopRight", LazyAudioPlayerMinDesktopRight],
["AudioPlayerMinDesktop", LazyAudioPlayerMinDesktop],
["AudioPlayerMinMobileExpanded", LazyAudioPlayerMinMobileExpanded],
["AudioPlayerMinMobileLeft", LazyAudioPlayerMinMobileLeft],
["AudioPlayerMinMobileRight", LazyAudioPlayerMinMobileRight],
["AudioPlayerMinMobile", LazyAudioPlayerMinMobile],
["AudioPlayerMin", LazyAudioPlayerMin],
["AudioPlayer", LazyAudioPlayer],
["AuthConfirmationPage", LazyAuthConfirmationPage],
["AuthConfirmationSuccessPage", LazyAuthConfirmationSuccessPage],
["AuthForgottenPasswordNewPage", LazyAuthForgottenPasswordNewPage],
["AuthForgottenPasswordPage", LazyAuthForgottenPasswordPage],
["AuthFormButtonApple", LazyAuthFormButtonApple],
["AuthFormButtonGoogle", LazyAuthFormButtonGoogle],
["AuthFormConfirmationInstruction", LazyAuthFormConfirmationInstruction],
["AuthFormNewPassword", LazyAuthFormNewPassword],
["AuthFormPasswordInstruction", LazyAuthFormPasswordInstruction],
["AuthFormSigninSlim", LazyAuthFormSigninSlim],
["AuthFormSignin", LazyAuthFormSignin],
["AuthFormSignupPassword", LazyAuthFormSignupPassword],
["AuthFormSignupSlim", LazyAuthFormSignupSlim],
["AuthFormSignup", LazyAuthFormSignup],
["AuthForm", LazyAuthForm],
["AuthLoginPage", LazyAuthLoginPage],
["BlogPostItem", LazyBlogPostItem],
["BlogPostList", LazyBlogPostList],
["CheckoutPageBillingAddress", LazyCheckoutPageBillingAddress],
["CheckoutPageChangePlan", LazyCheckoutPageChangePlan],
["CheckoutPageChecklist", LazyCheckoutPageChecklist],
["CheckoutPageContactInfo", LazyCheckoutPageContactInfo],
["CheckoutPageDescription", LazyCheckoutPageDescription],
["CheckoutPageError", LazyCheckoutPageError],
["CheckoutPageExpressCheckout", LazyCheckoutPageExpressCheckout],
["CheckoutPageFooter", LazyCheckoutPageFooter],
["CheckoutPageLegalText", LazyCheckoutPageLegalText],
["CheckoutPageLogo", LazyCheckoutPageLogo],
["CheckoutPageOrSeperator", LazyCheckoutPageOrSeperator],
["CheckoutPageOrderDetails", LazyCheckoutPageOrderDetails],
["CheckoutPagePaymentMethods", LazyCheckoutPagePaymentMethods],
["CheckoutPagePricingSummary", LazyCheckoutPagePricingSummary],
["CheckoutPagePromoCodeInput", LazyCheckoutPagePromoCodeInput],
["CheckoutPageSecurityInfo", LazyCheckoutPageSecurityInfo],
["CheckoutPageSkeletonLoader", LazyCheckoutPageSkeletonLoader],
["CheckoutPage", LazyCheckoutPage],
["CourseActionsAccess", LazyCourseActionsAccess],
["CourseActionsBuyFixed", LazyCourseActionsBuyFixed],
["CourseActionsBuy", LazyCourseActionsBuy],
["CourseActionsFollow", LazyCourseActionsFollow],
["CourseActionsListen", LazyCourseActionsListen],
["CourseActionsNoAccess", LazyCourseActionsNoAccess],
["CourseActionsShareButton", LazyCourseActionsShareButton],
["CourseActionsShare", LazyCourseActionsShare],
["CourseCard", LazyCourseCard],
["CourseGrid", LazyCourseGrid],
["CourseLessonAccordion", LazyCourseLessonAccordion],
["CourseListItemMentor", LazyCourseListItemMentor],
["CourseListItemSkeleton", LazyCourseListItemSkeleton],
["CourseListItem", LazyCourseListItem],
["CourseModal", LazyCourseModal],
["CourseOfTheWeekCourse", LazyCourseOfTheWeekCourse],
["CourseOfTheWeek", LazyCourseOfTheWeek],
["CourseRatingsItem", LazyCourseRatingsItem],
["CourseRatings", LazyCourseRatings],
["CourseRecommendation", LazyCourseRecommendation],
["CourseSearchModal", LazyCourseSearchModal],
["CourseSearch", LazyCourseSearch],
["CourseSlider", LazyCourseSlider],
["CourseBundleCourseSingle", LazyCourseBundleCourseSingle],
["CourseBundleCourses", LazyCourseBundleCourses],
["CourseBundleCtaTrial", LazyCourseBundleCtaTrial],
["CourseBundleListItem", LazyCourseBundleListItem],
["CourseBundleSlider", LazyCourseBundleSlider],
["CourseCategoryBundles", LazyCourseCategoryBundles],
["CourseCategoryCourses", LazyCourseCategoryCourses],
["CourseCategoryDropdown", LazyCourseCategoryDropdown],
["CourseCategoryFeaturedCategories", LazyCourseCategoryFeaturedCategories],
["CourseCategoryFeaturedCourses", LazyCourseCategoryFeaturedCourses],
["CourseCategoryFeatured", LazyCourseCategoryFeatured],
["CourseCategoryFilterSkeleton", LazyCourseCategoryFilterSkeleton],
["CourseCategoryFilter", LazyCourseCategoryFilter],
["CourseCategoryHeaderSkeleton", LazyCourseCategoryHeaderSkeleton],
["CourseCategoryHeader", LazyCourseCategoryHeader],
["CourseCategoryOverviewSliderCategories", LazyCourseCategoryOverviewSliderCategories],
["CourseCategoryOverviewSliderCoursesSlider", LazyCourseCategoryOverviewSliderCoursesSlider],
["CourseCategoryOverviewSliderCourses", LazyCourseCategoryOverviewSliderCourses],
["CourseCategoryOverviewSlider", LazyCourseCategoryOverviewSlider],
["CourseCategorySubcategories", LazyCourseCategorySubcategories],
["CourseCategorySubcategory", LazyCourseCategorySubcategory],
["CourseLandingpageCtaButton", LazyCourseLandingpageCtaButton],
["CourseLandingpageDescription", LazyCourseLandingpageDescription],
["CourseLandingpageDownloads", LazyCourseLandingpageDownloads],
["CourseLandingpageFeatures", LazyCourseLandingpageFeatures],
["CourseLandingpageForMe", LazyCourseLandingpageForMe],
["CourseLandingpageHeaderCourse", LazyCourseLandingpageHeaderCourse],
["CourseLandingpageHeaderKnownFroms", LazyCourseLandingpageHeaderKnownFroms],
["CourseLandingpageHeader", LazyCourseLandingpageHeader],
["CourseLandingpageInfo", LazyCourseLandingpageInfo],
["CourseLandingpageLearnings", LazyCourseLandingpageLearnings],
["CourseLandingpageLessonsAccordion", LazyCourseLandingpageLessonsAccordion],
["CourseLandingpageLessons", LazyCourseLandingpageLessons],
["CourseLandingpageMentorAbout", LazyCourseLandingpageMentorAbout],
["CourseLandingpageMentorQualifications", LazyCourseLandingpageMentorQualifications],
["CourseLandingpagePageNavigation", LazyCourseLandingpagePageNavigation],
["CourseLandingpageWyg", LazyCourseLandingpageWyg],
["CourseWidgetCommunity", LazyCourseWidgetCommunity],
["CourseWidgetContent", LazyCourseWidgetContent],
["CourseWidgetInfoSectionAbout", LazyCourseWidgetInfoSectionAbout],
["CourseWidgetInfoSectionDownloads", LazyCourseWidgetInfoSectionDownloads],
["CourseWidgetInfoSectionIntro", LazyCourseWidgetInfoSectionIntro],
["CourseWidgetInfoSectionLearnings", LazyCourseWidgetInfoSectionLearnings],
["CourseWidgetInfoSectionLessonsAccordion", LazyCourseWidgetInfoSectionLessonsAccordion],
["CourseWidgetInfoSectionLessons", LazyCourseWidgetInfoSectionLessons],
["CourseWidgetInfoSectionMentorInfo", LazyCourseWidgetInfoSectionMentorInfo],
["CourseWidgetInfoSectionMentorQualifications", LazyCourseWidgetInfoSectionMentorQualifications],
["CourseWidgetInfoSectionWyg", LazyCourseWidgetInfoSectionWyg],
["CourseWidgetInfo", LazyCourseWidgetInfo],
["CourseWidgetLessonCard", LazyCourseWidgetLessonCard],
["CourseWidgetLessons", LazyCourseWidgetLessons],
["CourseWidgetSkeleton", LazyCourseWidgetSkeleton],
["CourseWidget", LazyCourseWidget],
["IndexAwardItem", LazyIndexAwardItem],
["IndexAwardsSlider", LazyIndexAwardsSlider],
["IndexAwards", LazyIndexAwards],
["IndexFeatures", LazyIndexFeatures],
["IndexFounders", LazyIndexFounders],
["IndexHeader", LazyIndexHeader],
["IndexHighlightsSlider", LazyIndexHighlightsSlider],
["IndexMentorBg", LazyIndexMentorBg],
["IndexQuote", LazyIndexQuote],
["IndexReasonItem", LazyIndexReasonItem],
["IndexReasons", LazyIndexReasons],
["IndexTestimonialsItem", LazyIndexTestimonialsItem],
["IndexTestimonials", LazyIndexTestimonials],
["Container", LazyContainer],
["ContentSection", LazyContentSection],
["GridComponent", LazyGridComponent],
["Page", LazyPage],
["Post", LazyPost],
["TheAppFooter", LazyTheAppFooter],
["TheAppNavMainDropdownPop", LazyTheAppNavMainDropdownPop],
["TheAppNavMainDropdown", LazyTheAppNavMainDropdown],
["TheAppNavMainLg", LazyTheAppNavMainLg],
["TheAppNavMainSm", LazyTheAppNavMainSm],
["TheAppNavMainXs", LazyTheAppNavMainXs],
["TheAppNavMain", LazyTheAppNavMain],
["TheCookiePopup", LazyTheCookiePopup],
["ThePageNavigationList", LazyThePageNavigationList],
["LiveCallItemVideo", LazyLiveCallItemVideo],
["LiveCallItem", LazyLiveCallItem],
["LiveCallSessionButton", LazyLiveCallSessionButton],
["LiveCallSessionDetails", LazyLiveCallSessionDetails],
["LiveCallSessionSuccess", LazyLiveCallSessionSuccess],
["LiveCallSessionTimer", LazyLiveCallSessionTimer],
["LiveCallSessionVideo", LazyLiveCallSessionVideo],
["LiveCallSignupForm", LazyLiveCallSignupForm],
["LiveCallSlider", LazyLiveCallSlider],
["LiveCalls", LazyLiveCalls],
["MentorListItemSkeleton", LazyMentorListItemSkeleton],
["MentorListItem", LazyMentorListItem],
["MentorSlider", LazyMentorSlider],
["AppScreen1", LazyAppScreen1],
["AppScreen10", LazyAppScreen10],
["AppScreen11", LazyAppScreen11],
["AppScreen2", LazyAppScreen2],
["AppScreen3", LazyAppScreen3],
["AppScreen4", LazyAppScreen4],
["AppScreen5", LazyAppScreen5],
["AppScreen6", LazyAppScreen6],
["AppScreen7", LazyAppScreen7],
["AppScreen8", LazyAppScreen8],
["AppScreen9", LazyAppScreen9],
["OnboardingCreateAccountForm", LazyOnboardingCreateAccountForm],
["OnboardingSelectPlan", LazyOnboardingSelectPlan],
["OnboardingTopicModalCategorySkeleton", LazyOnboardingTopicModalCategorySkeleton],
["OnboardingTopicModalCategory", LazyOnboardingTopicModalCategory],
["OnboardingTopicModal", LazyOnboardingTopicModal],
["RedeemChooseCourseItem", LazyRedeemChooseCourseItem],
["RedeemChooseCourse", LazyRedeemChooseCourse],
["RedeemPageChoose", LazyRedeemPageChoose],
["RedeemPage", LazyRedeemPage],
["RedeemStepLogin", LazyRedeemStepLogin],
["RedeemStepValidation", LazyRedeemStepValidation],
["AudioComponent", LazyAudioComponent],
["AvatarGroup", LazyAvatarGroup],
["BannerApp", LazyBannerApp],
["BottomBarFixed", LazyBottomBarFixed],
["Breadcrumbs", LazyBreadcrumbs],
["ButtonComponent", LazyButtonComponent],
["CheckList", LazyCheckList],
["ClampedText", LazyClampedText],
["CountdownTimer", LazyCountdownTimer],
["ErrorComponent", LazyErrorComponent],
["FaqComponent", LazyFaqComponent],
["FaqQuestion", LazyFaqQuestion],
["FeatureListItem", LazyFeatureListItem],
["FeatureList", LazyFeatureList],
["FormComponentInput", LazyFormComponentInput],
["FormComponentSuccess", LazyFormComponentSuccess],
["FormComponent", LazyFormComponent],
["FormInput", LazyFormInput],
["FortuneWheelComponent", LazyFortuneWheelComponent],
["HeaderComponent", LazyHeaderComponent],
["HtmlComponent", LazyHtmlComponent],
["Illustration", LazyIllustration],
["ImageComponent", LazyImageComponent],
["LogoCloud", LazyLogoCloud],
["Logo", LazyLogo],
["ModalComponent", LazyModalComponent],
["ProcessComponent", LazyProcessComponent],
["ProgressRing", LazyProgressRing],
["ReviewComponent", LazyReviewComponent],
["ReviewItem", LazyReviewItem],
["ReviewSliderComponent", LazyReviewSliderComponent],
["RichTextComponent", LazyRichTextComponent],
["ShareButtons", LazyShareButtons],
["ShareComponent", LazyShareComponent],
["SitemapComponent", LazySitemapComponent],
["StarComponent", LazyStarComponent],
["StarRatingComponent", LazyStarRatingComponent],
["TallyForm", LazyTallyForm],
["TheBannerTop", LazyTheBannerTop],
["VimeoComponent", LazyVimeoComponent],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
